import { render } from "./CharTabDnD.vue?vue&type=template&id=0e30b88c"
import script from "./CharTabDnD.vue?vue&type=script&lang=js"
export * from "./CharTabDnD.vue?vue&type=script&lang=js"

import "./CharTabDnD.vue?vue&type=style&index=0&id=0e30b88c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__